import React from 'react';
import styled from 'styled-components';
import { Section, SectionContent } from '../../components/Section';
import { Heading } from '../../components/typography/Heading';
import { SubHeading } from '../../components/typography/SubHeading';
import { SplitContainer, ImageContainer, ContentContainer } from '../../components/layout/SplitLayout';
import BackgroundImage from '../../assets/PurposeBackground.jpg';
import { FaRegClock } from 'react-icons/fa';
import { FiUsers } from 'react-icons/fi';
import { LuBuilding2 } from 'react-icons/lu';
import { PiChartLineUp } from 'react-icons/pi';
import { ServiceCard, CardVariant } from '../../components/ServiceCard';
import { Service } from '../ServicesSection';

const services: Service[] = [
  {
    icon: LuBuilding2,
    title: 'Client First',
    description:
      "Treat the investor's interest as paramount, exercising due diligence, care, and independent professional judgment in all recommendations and transactions.",
  },
  {
    icon: PiChartLineUp,
    title: 'Full Transparency',
    description:
      'Avoid conflicts of interest, and where unavoidable, make full disclosures to ensure fair treatment of clients.',
  },
  {
    icon: FiUsers,
    title: 'Client Suitability',
    description:
      'Ensure that recommendations are based on client suitability—not on financial incentives or commissions.',
  },
  {
    icon: FaRegClock,
    title: 'Ethical Practice',
    description:
      'Uphold a culture of ethics and integrity, avoiding aggressive sales tactics and any unfair or misleading practices.',
  },
];

const StyledHeading = styled(Heading)`
  font-size: 2.5rem;
  line-height: 1.2;
  margin-bottom: 3rem;

  em {
    font-style: italic;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 90%;
    font-size: 1.5rem;
    margin: ${({ theme }) => theme.spacing.sm} 0;
  }
`;

const OneByOneGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: ${({ theme }) => theme.spacing.md};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
    gap: ${({ theme }) => theme.spacing.sm};
  }
`;

const StyledSection = styled(Section)`
  padding: 0;
`;

const StyledSectionContent = styled(SectionContent)`
  padding: 80px 0;
  max-width: none;
`;

const StyledContentContainer = styled(ContentContainer)`
  padding: 4rem 6rem 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 0 ${({ theme }) => theme.spacing.sm};
  }
`;

export const OurPromise: React.FC = () => {
  return (
    <StyledSection backgroundColor="white">
      <StyledSectionContent>
        <SplitContainer>
          <StyledContentContainer>
            <SubHeading>OUR PROMISE</SubHeading>
            <StyledHeading>Your Trust is our true wealth</StyledHeading>
            <OneByOneGrid>
              {services.map((service, index) => (
                <ServiceCard key={index} {...service} variant={CardVariant.Minimal} />
              ))}
            </OneByOneGrid>
          </StyledContentContainer>
          <ImageContainer>
            <img src={BackgroundImage} alt="Business professionals analyzing data" />
          </ImageContainer>
        </SplitContainer>
      </StyledSectionContent>
    </StyledSection>
  );
};
